import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../lib/supabase/client';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [redirecting, setRedirecting] = useState<boolean>(false);

  useEffect(() => {
    console.log('Auth callback initiated');
    console.log('Current URL:', window.location.href);
    console.log('Search params:', location.search);
    console.log('Environment:', {
      NODE_ENV: import.meta.env.MODE,
      Current_Origin: window.location.origin,
      Hostname: window.location.hostname
    });
    
    const handleAuthCallback = async () => {
      try {
        if (!supabase) {
          console.error('Supabase client is not initialized');
          throw new Error('Supabase client not initialized');
        }
        
        console.log('Processing OAuth callback');
        
        // Get the code from the URL if it exists
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        
        console.log('Auth code present:', !!code);
        
        if (code) {
          console.log('Exchanging code for session');
          // Exchange code for session
          const { data: exchangeData, error: exchangeError } = await supabase.auth.exchangeCodeForSession(code);
          
          if (exchangeError) {
            console.error('Code exchange error:', exchangeError);
            throw exchangeError;
          }
          
          console.log('Code exchange successful:', !!exchangeData?.session);
          
          if (!exchangeData?.session) {
            throw new Error('No session data received after code exchange');
          }
        }
        
        // Get the current session
        console.log('Getting current session');
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Session error:', error);
          throw error;
        }
        
        if (!data?.session) {
          console.error('No session found after authentication');
          throw new Error('Authentication failed - no session found');
        }
        
        console.log('Session obtained successfully');
        setRedirecting(true);
        
        // Check if there's a saved redirect path in sessionStorage
        const redirectPath = sessionStorage.getItem('redirectTo') || '/';
        console.log('Redirecting to:', redirectPath);
        
        // Add a short delay to make sure the auth context has time to update
        // This can help prevent the loading state issue
        console.log('Adding short delay before navigation to ensure auth state updates');
        setTimeout(() => {
          console.log('Navigating to saved path after delay:', redirectPath);
          // Clear the saved path
          sessionStorage.removeItem('redirectTo');
          navigate(redirectPath, { replace: true });
        }, 500); // 500ms delay should be enough for state to propagate
      } catch (err) {
        console.error('Error during authentication callback:', err);
        const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
        setError(`Authentication failed: ${errorMessage}`);
        setTimeout(() => {
          setRedirecting(true);
          navigate('/login', { replace: true });
        }, 5000);
      }
    };

    handleAuthCallback();
  }, [navigate, location]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      {error && !redirecting ? (
        <div className="text-red-500 mb-4">{error}</div>
      ) : (
        <>
          <div className="text-xl mb-4">Completing sign in...</div>
          <div className="w-12 h-12 border-4 border-t-primary rounded-full animate-spin"></div>
        </>
      )}
    </div>
  );
} 